export function normalizeNumber(value) {
  const rounded = Number(value?.toFixed(10));

  return Math.trunc(rounded * 100) / 100;
}
